<template>
  <div class="page" ref="page" :style="pageStyle" :class="{ 'preview-mode': isPreview }" @mouseover="onPageMouseover" @mouseleave="hoverKey = ''">
    <PageLoading v-if="loading"></PageLoading>    
    <TipsWechat ref="child" v-if="platform==2"></TipsWechat>
    <TipsZonglan ref="child" v-if="platform==3"></TipsZonglan>
    <TipsHbrb ref="child" v-if="platform==4"></TipsHbrb>
    <div v-if="isPreview && hoverKey" class="edit-hover-btn" :style="editBtnStyle" @click="editElement(hoverKey)"><span><i class="huodong icon-AIhuihua"></i>{{ editBtnText }}</span></div>
    <div class="logo-box" :style="logoWrapStyle" @pointerdown="startDrag($event, 'logo')">
      <img v-if="logoImg" class="logo-img" :class="logoAnimClass" :src="logoImg" alt="" />
      <span v-if="isPreview" class="resize-handle resize-tl" @pointerdown.stop="startResize($event, 'logo', 'tl')"></span>
      <span v-if="isPreview" class="resize-handle resize-tr" @pointerdown.stop="startResize($event, 'logo', 'tr')"></span>
      <span v-if="isPreview" class="resize-handle resize-bl" @pointerdown.stop="startResize($event, 'logo', 'bl')"></span>
      <span v-if="isPreview" class="resize-handle resize-br" @pointerdown.stop="startResize($event, 'logo', 'br')"></span>
    </div>
    <div
      v-for="btn in indexStyle.buttons"
      :key="btn.key"
      class="act-btn"
      :data-key="btn.key"
      :style="buttonStyle(btn)"
      @pointerdown="startDrag($event, 'button', btn)"
      @click="handleButton(btn)"
    >
      <img v-if="btn.img" :class="btnAnimClass(btn)" :src="btn.img" alt="" />
      <span v-if="isPreview" class="resize-handle resize-tl" @pointerdown.stop="startResize($event, 'button', 'tl', btn)"></span>
      <span v-if="isPreview" class="resize-handle resize-tr" @pointerdown.stop="startResize($event, 'button', 'tr', btn)"></span>
      <span v-if="isPreview" class="resize-handle resize-bl" @pointerdown.stop="startResize($event, 'button', 'bl', btn)"></span>
      <span v-if="isPreview" class="resize-handle resize-br" @pointerdown.stop="startResize($event, 'button', 'br', btn)"></span>
    </div>

    <!-- 活动规则 -->
    <van-popup v-model="showNotice" closeable close-icon="close" position="bottom" round>          
      <div class="noticBox">        
        <h2 class="noticTitle">
          <span class="line"></span>
          <span class="text">活动规则</span>
          <span class="line"></span>
        </h2>
        <div class="noticTxt" v-html="actExtend.explain"></div>
      </div>
    </van-popup>

    <!-- 登录弹窗 -->
    <van-popup v-model="showLogin" closeable close-icon="close" position="bottom" round>
      <div class="loginBox">
        <h2 class="loginTitle">参与活动</h2>
        <van-form ref="loginForm" @submit="onLoginSubmit">
          <van-field v-if="loginNeedAccount" v-model="loginAccount" name="account" placeholder="请输入账号" :rules="[{ required: true, message: '请输入账号' }]">
            <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="lianxiren" size="20"></van-icon>
          </van-field>       
          <van-field v-if="loginNeedPassCode" v-model="loginPassCode" name="pass_code" placeholder="请输入口令" :rules="[{ required: true, message: '请输入口令' }]">
            <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="quanxianguanli" size="20"></van-icon>
          </van-field>       
          <van-field v-if="loginNeedPhone" v-model="loginPhone" name="phone" class="loginPhoneBox" placeholder="请输入手机号" :rules="[{ required: true, message: '请输入手机号' }]">
            <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="shiwu-shoujidefuben" size="20"></van-icon>
            <template #button>
              <van-button size="small" type="primary" native-type="button" class="sendCodeBtn" :disabled="loginCodeTime > 0" @click="sendLoginCode">{{ loginCodeTime > 0 ? loginCodeTime + 's后重发' : '发送验证码' }}</van-button>
            </template>
          </van-field>
          <van-field v-if="loginNeedPhone" v-model="loginSmsCode" name="sms_code" placeholder="请输入验证码" :rules="[{ required: true, message: '请输入验证码' }]">
            <van-icon class="iconfont" class-prefix="icon" slot="left-icon" name="suo" size="20"></van-icon>
          </van-field>       
          <div class="loginBtn">
            <van-button round block type="info" native-type="submit">登录</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  
    <stat :actId="Number(learnid)" :actTitle="actInfo.title" :platform="Number(platform)" v-if="learnid"></stat>
    <LotteryBox v-if="actInfo.dis_btn && (actInfo.dis_btn.includes('cj'))" :lotteryid="Number(actInfo.bind_lotteryid)"></LotteryBox>
  </div>
</template>

<script>
//公共组件
import PageLoading from '@/components/PageLoading.vue'
import TipsWechat from '@/components/TipsWechat.vue'
import TipsZonglan from '@/components/TipsZonglan.vue'
import TipsHbrb from '@/components/TipsHbrb.vue'
import stat from '@/components/stat.vue'
import LotteryBox from '@/components/LotteryBox.vue'
//数据接口
import {reqLearnInfo,reqIsReg,reqLearnExtend,reqLogin,reqSendCode,reqJoin} from '@/api/learn.js'

//工具函数
import { getClientId } from '@/utils/common.js'
import Cookies from 'js-cookie'
import dayjs from "dayjs"
import { isColorDark, checkClient } from "@/utils/tool";
import { Dialog } from 'vant';
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'

export default {
  name: 'index',
  components: {
    PageLoading,TipsWechat, TipsZonglan, TipsHbrb, stat, LotteryBox,
  },
  data () {
    return {
      loading:false,
      platform:0, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端      
      accessid:'', 
      openid:'', //微信用户openid   
      accountId:'',
      uniqueId:'',
      token:"",      
      learnid:0,
      actInfo:{
        title:'',
        bgcolor:'',
        color:'',
        share_logo:'',
        share_url:'',
        unshare:'',
        bg_indexfor:'',
        bg_start:'',
        bg_exam:'',
        bind_examid:'',
      },  
      actExtend:{},  
      title:"",          
      showNotice:false,
      style:{},
      explain:"",
      isBgDark:false,
      // 首页元素配置（页面背景/Logo/活动按钮）
      indexStyle: {
        pageBg: '',
        logo: { img: '', x: 50, y: 10, scale: 1, anim: 'tada', ratio: 1 },
        buttons: []
      },
      // 预览模式：拖拽/缩放进行中标志（用于忽略后台回显，避免对象被替换导致拖拽失效）
      dragging: false,
      // 预览模式：当前 hover 的可编辑区域 key（logo/按钮 key/pageBg）
      hoverKey: '',
      // 登录弹窗
      showLogin:false,
      loginAccount:'',
      loginPhone:'',
      loginSmsCode:'',
      loginPassCode:'',
      loginCodeTime:0,
      loginTimer:null,
      // 登录/登记成功后待跳转的目标页（如 /rank、/list）
      nextPath:'',
      // 课程类型：1视频学习 2图文学习
      listType:'',
    }
  },  
  created (){
    this.platform = this.$route.query.platform;
    this.learnid = this.$route.query.learnid;

    if(!this.platform) {
      this.loading = false
      this.$toast({
        icon: 'warning-o',
        message: '活动地址错误',
        duration: 0
      });
      return false;
    }

    // 恢复H5/电脑端登录token
    if(this.learnid) {
      const t = localStorage.getItem(this.learnid + '_token');
      if(t) {
        this.token = t;
        this.$store.commit("SET_TOKEN", t);
      }
    }

    if(this.learnid) {
      this.getActInfo();  //加载活动信息
    } else {
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在'
      });
    }
  },
  mounted () {
    // 预览模式：监听后台推送的首页元素配置
    window.addEventListener('message', this.onMessage);
    if (this.isPreview) {
      window.parent.postMessage({ type: 'learn-style-ready' }, '*');
    }
  },  
  beforeDestroy(){
    if(this.loginTimer) clearInterval(this.loginTimer);
    window.removeEventListener('message', this.onMessage);
  },
  computed: {
    // 是否处于后台预览模式（通过 iframe + preview=1 打开）
    isPreview() {
      const p = this.$route.query.preview;
      return p === '1' || p === 1 || p === true;
    },
    // 页面样式：主题色、背景色、背景图（兼容旧字段 bg_index）
    pageStyle() {
      const style = {
        '--styleColor': this.actInfo.color,
        '--bgColor': this.actInfo.bgcolor
      };
      const bg = this.indexStyle.pageBg;
      if (bg) {
        style.backgroundImage = 'url(' + bg + ')';
        style.backgroundSize = '100%';
        style.backgroundRepeat = 'no-repeat';
        style.backgroundPosition = 'left top';
      }
      return style;
    },
    // Logo 图片与动画
    logoImg() {
      return this.indexStyle.logo.img || '';
    },
    logoAnimClass() {
      const anim = this.indexStyle.logo.anim;
      return anim ? 'anim-' + anim : '';
    },
    logoWrapStyle() {
      const l = this.indexStyle.logo;
      // 基准宽 162px（设计稿），高度按图片宽高比计算；内联样式不经 pxtorem 处理，手动换算 rem
      const scale = l.scale || 1;
      const wRem = (162 / 75) * scale;
      const hRem = wRem / (l.ratio || 1);
      return {
        left: l.x + '%',
        top: l.y + '%',
        width: wRem + 'rem',
        height: hRem + 'rem',
        transform: 'translate(-50%, -50%)'
      };
    },
    // 预览模式：hover 编辑按钮的定位（pageBg 固定右上角，logo/按钮跟随区域中心）
    editBtnStyle() {
      if (this.hoverKey === 'pageBg') {
        return { right: '20px', top: '20px', transform: 'none' };
      }
      if (this.hoverKey === 'logo') {
        return { left: this.indexStyle.logo.x + '%', top: this.indexStyle.logo.y + '%' };
      }
      const btn = this.indexStyle.buttons.find(b => b.key === this.hoverKey);
      if (btn) {
        return { left: btn.x + '%', top: btn.y + '%' };
      }
      return { display: 'none' };
    },
    // 预览模式：悬浮编辑按钮文字
    editBtnText() {
      return this.hoverKey === 'pageBg' ? '首页背景' : '编辑';
    },
    // 登录弹窗是否需要填写账号（账号口令）
    loginNeedAccount(){
      return Number(this.actInfo.permiss) === 3;
    },
    // 登录弹窗是否需要填写口令（账号口令/统一口令/多口令）
    loginNeedPassCode(){
      return [1,2,3].includes(Number(this.actInfo.permiss));
    },
    // 登录弹窗是否需要填写手机号+验证码（短信验证/统一口令/多口令：微信/H5/电脑端需要，客户端已含手机号无需）
    loginNeedPhone(){
      const p = Number(this.actInfo.permiss);
      if([1,2,4].includes(p)) return [1,2,5].includes(Number(this.platform));
      return false;
    },
  },
  methods: {
    loginInit(){
      // this.loading = false
    },
    getActInfo(){
      this.loading = true
      reqLearnInfo({platform:this.platform, learnid:this.learnid}).then(res => {
        this.loading = false
        if(res.code==200) {
  
          this.actInfo = res.data.info;        
          this.indexStyle = this.parseIndexStyle(res.data.info.index_style);
          this.groups = res.data.groups;          
          this.$store.commit("SET_ACTINFO",res.data.info); 
          this.$store.commit("SET_GROUPS",res.data.groups);

          document.title = this.actInfo.title; //设置页面title
          this.isBgDark = isColorDark(this.actInfo.bgcolor);

          //不强制则根据客户端判断来源平台
          if(this.actInfo.force_app==0) { 
            if(this.platform == getClientId() || !this.actInfo.platform.split(',').includes(String(getClientId()))){
              console.log('平台端无需切换');              
            } else {
              this.platform = getClientId();
              // 修正URL中的platform参数为当前客户端识别的正确平台
              this.$router.replace({
                query: {
                  ...this.$route.query,
                  platform: this.platform
                }
              })
            }
          }
          this.checkTime();
          //分享设置
          wxShare({
            title: this.actInfo.share_title,
            desc: this.actInfo.share_desc,
            img: this.actInfo.share_logo,
            shareUrl: this.actInfo.share_url,
            unShare: this.actInfo.unshare,
          })

        } else {
          this.loading = false
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }
      }).catch(err => {
        this.loading = false
        this.$toast({
              icon: 'warning-o',
              message: err
          });
      }) 

    },
    // 进入课程列表：type 1视频学习 2图文学习
    toList(type){
      this.listType = type;
      this.nextPath = '/list'; // 登录/登记成功后进入课程列表
      if(Number(this.actInfo.permiss) === 0){
        // 公开活动：免登录，建档后按是否登记进入
        if(!this.checkIdentity()) return;
        const enter = () => {
          if(this.actInfo.isreg == 1){
            this.isReg();
          } else {
            this.$router.push({ path: '/list', query:this.navQuery() });
          }
        };
        this.joinAct().then(enter, enter);
        return;
      }
      // 非公开活动：需登录，统一走登记/登录链路
      this.toReg();
    },
    toLearn(){
      this.toList('1');
    },
    toArt(){
      this.toList('2');
    },
    // 进入排行榜：按 permiss/isreg 校验后跳转，权限链路与「开始学习」一致
    toRank(){
      // 排行榜未开启则不响应
      if(!(this.actInfo.dis_btn && this.actInfo.dis_btn.includes('phb'))){
        this.$toast({ icon: 'warning-o', message: '排行榜暂未开启' });
        return;
      }
      this.listType = ''; // 排行榜无需课程类型
      this.nextPath = '/rank'; // 登录/登记成功后进入排行榜
      if(Number(this.actInfo.permiss) === 0){
        // 公开活动：免登录，建档后按是否登记进入排行榜
        if(!this.checkIdentity()) return;
        const enter = () => {
          if(this.actInfo.isreg == 1){
            this.isReg('/rank');
          } else {
            this.$router.push({ path: '/rank', query:{...this.$route.query} });
          }
        };
        this.joinAct().then(enter, enter);
        return;
      }
      // 非公开活动：需登录，统一走登记/登录链路
      this.toReg('/rank');
    },
    // 校验平台身份（微信openid/客户端account_id/PC·H5 token），通过返回true
    checkIdentity(){
      if(this.platform == 2){
        this.accessid = this.$store.state.accessid;
        this.openid = this.$store.state.openid;
        if(this.accessid && this.openid) return true;
        Dialog.confirm({
          title: '消息提示',
          message: '请微信授权后参与活动',
        }).then(() => {}).catch(() => {});
        return false;
      }
      if(this.platform == 3 || this.platform == 4){
        this.accountId = this.$store.state.accountId;
        this.uniqueId = this.$store.state.uniqueId;
        if(this.accountId && this.uniqueId) return true;
        Dialog.confirm({
          title: '消息提示',
          message: '请登录客户端后参与活动',
        }).then(() => {
          if(this.$refs && this.$refs.child){ this.$refs.child.toLink(); }
        }).catch(() => {});
        return false;
      }
      // PC/H5：非公开需token，公开无需登录
      if(Number(this.actInfo.permiss) === 0) return true;
      if(this.token) return true;
      this.showLogin = true;
      return false;
    },
    // 参与建档（幂等，公开活动「开始学习」即建档）
    joinAct(){
      let data = { platform:this.platform, learnid:this.learnid };
      if(this.platform == 2){
        data.accessid = this.accessid;
        data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
        data.account_id = this.accountId;
        data.unique_id = this.uniqueId;
      }
      if(this.platform == 1 || this.platform == 5){
        data.token = this.token;
      }
      return reqJoin(data);
    },
    toReg(nextPath){
      if(!this.checkIdentity()) return;
      this.isReg(nextPath);
    },
    isReg(nextPath){
      const target = nextPath || '/list';
      this.loading = true;
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
      }      
      if(this.platform == 2){               
          data.accessid = this.accessid;
          data.openid = this.openid;
      }
      if(this.platform == 3 || this.platform == 4){
          data.account_id = this.accountId;
          data.unique_id = this.uniqueId;
      }  
      if(this.platform == 1 || this.platform == 5){
          data.token = this.token;
      }
      reqIsReg(data).then(res => {
          if(res.code==200) {
              this.loading = false;
              if(res.data.isreg){ //当前用户有登录记录
                if(this.platform == 2){      
                   localStorage.setItem(this.learnid+'_markField', this.openid);
                } 
                if(this.platform == 3 || this.platform == 4){
                   localStorage.setItem(this.learnid+'_markField', this.accountId);
                }               
                localStorage.setItem(this.learnid+'_viewed', res.data.viewed);   

                this.$router.push({ path: target,query:this.navQuery() })  //直接进入课程列表页
              } else if(res.data.islogin){
                Cookies.set('ckplayer-player-cookie','') //已登录未登记，清空观看记录           
                localStorage.setItem(this.learnid+'_viewed', '');
                if(this.actInfo.isreg == 1){
                  this.$router.push({ path: '/reg',query:this.navQuery() })  //进入信息登记页
                } else {
                  this.$router.push({ path: target,query:this.navQuery() })  //不登记直接进入课程列表页
                }
              } else {
                Cookies.set('ckplayer-player-cookie','') //未登录，清空观看记录           
                localStorage.setItem(this.learnid+'_viewed', '');
                // 公开活动：无需登录，直接按是否登记进入
                if(Number(this.actInfo.permiss) === 0){
                  if(this.actInfo.isreg == 1){
                    this.$router.push({ path: '/reg',query:this.navQuery() })
                  } else {
                    this.$router.push({ path: target,query:this.navQuery() })
                  }
                }
                // 客户端(3/4)短信验证(permiss==4)：用户信息已含手机号，直接静默登录
                else if((this.platform == 3 || this.platform == 4) && Number(this.actInfo.permiss) === 4){
                  this.clientAutoLogin();
                } else {
                  this.showLogin = true; // 弹登录窗
                }
              }        
          } else {
              this.loading = false;
              // H5/电脑 token失效时清除并重新登录
              if(this.platform == 1 || this.platform == 5){
                  localStorage.removeItem(this.learnid+'_token');
                  this.token = '';
                  this.$store.commit("SET_TOKEN", '');
              }
              this.$toast({
                  icon: 'warning-o',
                  message: res.msg,
              });
          }
          
      }).catch(() => {
          this.loading = false
      }) 
    },
    // 登录弹窗提交
    onLoginSubmit(){
      if(!this.$refs.loginForm){
        return;
      }
      this.$refs.loginForm.validate().then(() => {
        let data = {
            platform:this.platform,
            learnid:this.learnid, 
        }      
        if(this.platform == 2){               
            data.accessid = this.accessid;
            data.openid = this.openid;
        }
        if(this.platform == 3 || this.platform == 4){
            data.account_id = this.accountId;
            data.unique_id = this.uniqueId;
        }  
        if(this.loginNeedAccount) data.account = this.loginAccount;
        if(this.loginNeedPassCode) data.pass_code = this.loginPassCode;
        if(this.loginNeedPhone) {
            data.phone = this.loginPhone;
            data.sms_code = this.loginSmsCode;
        }
        this.submitLogin(data);
      }).catch(() => {})
    },
    // 客户端(3/4)短信验证(permiss==4)静默登录：用户信息已含手机号，无需填写
    clientAutoLogin(){
      let data = {
          platform:this.platform,
          learnid:this.learnid, 
          account_id:this.accountId,
          unique_id:this.uniqueId,
      };
      this.submitLogin(data);
    },
    // 提交登录
    submitLogin(data){
      this.loading = true;
      reqLogin(data).then(res => {
        this.loading = false;
        if(res.code==200) {
          if(res.data.token){
            this.token = res.data.token;
            this.$store.commit("SET_TOKEN", res.data.token);
            localStorage.setItem(this.learnid+'_token', res.data.token);
          }
          this.showLogin = false;
          const target = this.nextPath || '/list';
          this.nextPath = '';
          if(res.data.isreg){
            this.$router.push({ path: target,query:this.navQuery() })  //已登记，进入目标页
          } else if(this.actInfo.isreg == 1){
            this.$router.push({ path: '/reg',query:this.navQuery() })  //进入信息登记页
          } else {
            this.$router.push({ path: target,query:this.navQuery() })  //不登记，进入目标页
          }
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg,
          });
        }
      }).catch(() => {
        this.loading = false;
      })
    },
    // 登录弹窗发送验证码
    sendLoginCode(){
      if(!this.loginPhone){
        this.$toast({ icon: 'warning-o', message: '请输入手机号' });
        return;
      }
      if(!/^1\d{10}$/.test(this.loginPhone)){
        this.$toast({ icon: 'warning-o', message: '手机号格式错误' });
        return;
      }
      this.loginCodeTime = 30;
      if(this.loginTimer) clearInterval(this.loginTimer);
      this.loginTimer = setInterval(() => {
        this.loginCodeTime--;
        if(this.loginCodeTime <= 0){
          clearInterval(this.loginTimer);
          this.loginTimer = null;
        }
      }, 1000);

      reqSendCode({platform:this.platform, learnid:this.learnid, phone:this.loginPhone}).then(res => {
        if(res.code==200) {
          this.$toast({ message: '验证码已发送' });
        } else {
          this.$toast({ icon: 'warning-o', message: res.msg });
        }
      }).catch(() => {})
    },
    checkTime(){
      let timeNow = Date.now();
      if(this.actInfo.start_time*1000>timeNow) {
        // console.log('未开始');
        this.actStat = 0;
      } else {
        if(this.actInfo.end_time*1000<timeNow) {
          // console.log('已结束');
          this.actStat = 2;
        } else {
          // console.log('进行中');
          this.actStat = 1; 
        }
      }
    },
    dateFormat(time){
      return dayjs(time).format("YYYY-MM-DD HH:mm");
    },
    noticeBox(){
      let data = {
          platform:this.platform, //来源平台：1电脑端，2微信端，3纵览客户端，4河北日报客户端，5H5端
          learnid:this.learnid, 
      }  

      this.loading = true
      reqLearnExtend(data).then(res => {
        this.loading = false
        if(res.code==200) {
          this.actExtend = res.data;        
          
        } else {
          this.$toast({
              icon: 'warning-o',
              message: res.msg
          });
        }        
        
      }).catch(() => {
        this.loading = false
      }) 
      this.showNotice = true;
    },  
    openApp(){
      jump2zonglan.toMLink()
    },    
    toHome(){
      this.$router.push({ path: '/index',query:this.$route.query })
    },
    toMyCenter(){
      this.$router.push({ path: '/mycenter',query:this.$route.query })
    },
    toExam(){
      const platform = this.$route.query.platform;
      const bind_examid = this.actInfo.bind_examid;
      const quiz_tpl = this.actInfo.quiz_tpl;
      if (!bind_examid) return;
      let url = process.env.VUE_APP_FRONTS_URL + quiz_tpl + '?id=' + bind_examid + '&platform=' + platform;
      // 纵览新闻客户端(3)、河北日报客户端(4)追加app_control参数
      if (platform === '3' || platform === '4') {
        url += '&app_control=1101';
      }
      window.open(url);
    },
    // 开始抽奖：跳转绑定抽奖活动（参照 LotteryBox.vue 的 toDraw）
    toDraw(){
      const platform = this.$route.query.platform;
      const tpl = this.actInfo.lottery_tpl;
      const lotteryid = this.actInfo.bind_lotteryid;
      if (!tpl || !lotteryid) return;
      let url = process.env.VUE_APP_FRONTS_URL + tpl + 'index?lotteryid=' + lotteryid + '&platform=' + platform;
      if (platform === '3' || platform === '4') {
        url += '&app_control=1101';
      }
      window.open(url);
    },
    // 外部链接
    openLink(url){
      if (!url) return;
      window.open(url);
    },
    // 触发动作名称
    actionName(action){
      const map = { learn: '视频学习', art: '图文学习', exam: '开始答题', draw: '开始抽奖', link: '外部链接', notice: '活动说明', none: '无动作', rank: '进入排行榜' };
      return map[action] || '按钮';
    },
    // 带课程类型的跳转 query（视频/图文学习进入列表时区分数据）
    navQuery(){
      const q = { ...this.$route.query };
      if (this.listType) q.type = this.listType;
      return q;
    },
    // 构造一个按钮配置项（保留已有 key）
    makeButton(action, title, img, fixed, x, y, scale, anim, ratio, url, key){
      return {
        key: key || ('btn_' + Date.now() + '_' + Math.random().toString(36).slice(2, 6)),
        title: title || this.actionName(action),
        img: img || '',
        x: typeof x === 'number' ? x : 50,
        y: typeof y === 'number' ? y : 50,
        scale: scale || 1,
        anim: anim || '',
        ratio: ratio || 1,
        action: action || 'learn',
        url: url || '',
        fixed: !!fixed
      };
    },
    // 解析后台下发的 index_style（字符串或对象），合并默认值并兼容旧字段
    parseIndexStyle(input){
      const act = this.actInfo || {};
      const def = {
        pageBg: act.bg_index || '',
        logo: { img: act.bg_indexfor || '', x: 50, y: 10, scale: 1, anim: 'tada', ratio: 1 },
        buttons: []
      };
      // 兼容旧字段：默认「开始学习」与「开始答题」按钮
      if (act.bg_start) {
        def.buttons.push(this.makeButton('learn', '开始学习', act.bg_start, true, 50, 50));
      }
      if (act.bind_examid && act.bg_exam) {
        def.buttons.push(this.makeButton('exam', '开始答题', act.bg_exam, false, 50, 62));
      }

      let obj = input;
      if (typeof input === 'string') {
        if (!input) return def;
        try {
          obj = JSON.parse(input);
        } catch (e) {
          return def;
        }
      }
      if (!obj || typeof obj !== 'object') return def;

      const buttons = (Array.isArray(obj.buttons) && obj.buttons.length)
        ? obj.buttons.map(b => this.makeButton(
            b.action, b.title, b.img, !!b.fixed, b.x, b.y, b.scale, b.anim, b.ratio, b.url, b.key
          ))
        : def.buttons;

      return {
        pageBg: obj.pageBg || def.pageBg,
        logo: Object.assign({}, def.logo, obj.logo || {}),
        buttons: buttons
      };
    },
    // 按钮动画 class
    btnAnimClass(btn){
      const anim = btn && btn.anim;
      return anim ? 'anim-' + anim : '';
    },
    // 按钮位置/尺寸样式（基准宽 300px，高度按图片宽高比计算）
    buttonStyle(btn){
      const scale = btn.scale || 1;
      const wRem = (300 / 75) * scale;
      const hRem = wRem / (btn.ratio || 1);
      return {
        left: btn.x + '%',
        top: btn.y + '%',
        width: wRem + 'rem',
        height: hRem + 'rem',
        transform: 'translate(-50%, -50%)'
      };
    },
    // 接收后台推送的配置
    onMessage(e){
      const data = e.data;
      if (!data || typeof data !== 'object') return;
      if (data.type === 'learn-style-preview') {
        // 拖拽/缩放进行中时忽略后台回显，避免 this.indexStyle 被整体替换导致 target 引用失效
        if (this.dragging) return;
        this.indexStyle = this.parseIndexStyle(data.payload);
      }
    },
    // 向后台回传拖拽/缩放结果
    emitChange(){
      if (!this.isPreview) return;
      window.parent.postMessage({ type: 'learn-style-change', payload: this.indexStyle }, '*');
    },
    // 预览模式：鼠标在页面内移动时，判断当前 hover 的可编辑区域
    onPageMouseover(e){
      if (!this.isPreview) return;
      const t = e.target;
      if (t.closest('.edit-hover-btn')) return;
      if (t.closest('.logo-box')) {
        this.hoverKey = 'logo';
      } else {
        const btn = t.closest('.act-btn');
        this.hoverKey = btn ? btn.getAttribute('data-key') : 'pageBg';
      }
    },
    // 拖拽移动 Logo / 按钮（仅预览模式）
    startDrag(e, type, btn){
      if (!this.isPreview) return;
      e.preventDefault();
      e.stopPropagation();
      const target = type === 'button' ? btn : this.indexStyle[type];
      const pageEl = this.$refs.page;
      if (!pageEl || !target) return;
      this.dragging = true;
      this.hoverKey = '';
      const rect = pageEl.getBoundingClientRect();
      const startX = e.clientX;
      const startY = e.clientY;
      const startPercentX = target.x;
      const startPercentY = target.y;

      if (e.currentTarget && e.currentTarget.setPointerCapture && e.pointerId != null) {
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
      }

      let raf = null;
      let lastEv = null;
      // 单帧只算一次、只改一次 DOM，避免高频 pointermove 造成重复回流与卡顿
      const applyMove = (ev) => {
        const dx = ((ev.clientX - startX) / rect.width) * 100;
        const dy = ((ev.clientY - startY) / rect.height) * 100;
        target.x = Math.min(100, Math.max(0, Math.round((startPercentX + dx) * 100) / 100));
        target.y = Math.min(100, Math.max(0, Math.round((startPercentY + dy) * 100) / 100));
      };
      const onMove = (ev) => {
        lastEv = ev;
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          if (lastEv) applyMove(lastEv);
        });
      };
      const onUp = () => {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (lastEv) applyMove(lastEv); // 落点补一次，保证最终坐标准确
        this.dragging = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        this.emitChange(); // 松手才回传一次
      };
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    },
    // 四角控制点等比拉伸 Logo / 按钮（仅预览模式）
    startResize(e, type, corner, btn){
      if (!this.isPreview) return;
      e.preventDefault();
      e.stopPropagation();
      const target = type === 'button' ? btn : this.indexStyle[type];
      const pageEl = this.$refs.page;
      const boxEl = e.currentTarget && e.currentTarget.parentElement;
      if (!target || !pageEl || !boxEl) return;
      this.dragging = true;
      this.hoverKey = '';

      const pageRect = pageEl.getBoundingClientRect();
      const boxRect = boxEl.getBoundingClientRect();
      const s0 = target.scale;
      const baseW = boxRect.width / s0;
      const baseH = boxRect.height / s0;
      // 最大可拉伸到页面宽度的 95%
      const maxScale = (pageRect.width * 0.95) / baseW;

      const signX = (corner === 'tr' || corner === 'br') ? 1 : -1;
      const signY = (corner === 'bl' || corner === 'br') ? 1 : -1;

      const centerX = boxRect.left + boxRect.width / 2 - pageRect.left;
      const centerY = boxRect.top + boxRect.height / 2 - pageRect.top;
      const ax = centerX - (signX * baseW * s0) / 2;
      const ay = centerY - (signY * baseH * s0) / 2;

      const dx = signX * baseW;
      const dy = signY * baseH;
      const dLen2 = dx * dx + dy * dy;

      if (e.currentTarget && e.currentTarget.setPointerCapture && e.pointerId != null) {
        try { e.currentTarget.setPointerCapture(e.pointerId); } catch (err) {}
      }

      let raf = null;
      let lastEv = null;
      // 单帧只算一次、只改一次 DOM，避免高频 pointermove 造成重复回流与卡顿
      const applyMove = (ev) => {
        const mx = ev.clientX - pageRect.left;
        const my = ev.clientY - pageRect.top;
        let s = (dx * (mx - ax) + dy * (my - ay)) / dLen2;
        s = Math.min(maxScale, Math.max(0.2, Math.round(s * 100) / 100));
        target.scale = s;
        const ncx = ax + (signX * baseW * s) / 2;
        const ncy = ay + (signY * baseH * s) / 2;
        const px = (ncx / pageRect.width) * 100;
        const py = (ncy / pageRect.height) * 100;
        target.x = Math.min(100, Math.max(0, Math.round(px * 100) / 100));
        target.y = Math.min(100, Math.max(0, Math.round(py * 100) / 100));
      };
      const onMove = (ev) => {
        lastEv = ev;
        if (raf) return;
        raf = requestAnimationFrame(() => {
          raf = null;
          if (lastEv) applyMove(lastEv);
        });
      };
      const onUp = () => {
        if (raf) { cancelAnimationFrame(raf); raf = null; }
        if (lastEv) applyMove(lastEv); // 落点补一次，保证最终比例/坐标准确
        this.dragging = false;
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
        this.emitChange(); // 松手才回传一次
      };
      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);
    },
    // 点击按钮：按触发动作分发（预览模式不触发）
    handleButton(btn){
      if (this.isPreview) return;
      if (!btn) return;
      switch (btn.action) {
        case 'learn': this.toLearn(); break;
        case 'art': this.toArt(); break;
        case 'exam': this.toExam(); break;
        case 'draw': this.toDraw(); break;
        case 'link': this.openLink(btn.url); break;
        case 'notice': this.noticeBox(); break;
        case 'rank': this.toRank(); break;
        case 'none': break;
      }
    },
    // 点击悬浮编辑按钮：通知后台打开对应设置弹窗（仅预览模式）
    editElement(key){
      if (!this.isPreview) return;
      window.parent.postMessage({ type: 'learn-style-edit', payload: { key } }, '*');
    }
  }
  
}
</script>
<style>
@media screen and (min-width: 1200px) {
  html,body { 
    display: flex; 
    justify-content: center; 
    font-size: 200px!important;
  }
}
</style>
<style lang="scss" scoped>
.page{
  width: 750px;
  min-height: 100vh;
  background: var(--bgColor);
  position: relative;
  // 首页元素：Logo / 活动按钮（绝对定位，预览模式可拖拽）
  .logo-box, .act-btn{
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 10;
    img{
      display: block;
      width: 100%;
      height: 100%;
    }
  }
  .act-btn{
    cursor: pointer;
  }
  // 预览模式：可编辑区域虚线框与拖拽光标
  &.preview-mode .logo-box,
  &.preview-mode .act-btn{
    outline: 4px dashed #1890ff;
    outline-offset: 0px;
    cursor: move;
    touch-action: none;
  }
  // 预览模式：悬浮编辑按钮（跟随 hover 区域中心）
  .edit-hover-btn{
    position: absolute;
    z-index: 9999;
    transform: translate(-50%, -50%);
    padding: 5px 18px;
    background: #188fffe2;
    color: #fff;
    font-size: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
    pointer-events: auto;
    i{
        font-size: 28px;
        margin-right: 3px;
        margin-top: 4px;
    }
  }
  // 预览模式：四角等比拉伸控制点（Logo / 按钮）
  .resize-handle{
    position: absolute;
    width: 16px;
    height: 16px;
    background: #fff;
    border: 2px solid #409eff;
    border-radius: 50%;
    z-index: 20;
    touch-action: none;
  }
  .resize-tl{ left: -8px; top: -8px; cursor: nwse-resize; }
  .resize-tr{ right: -8px; top: -8px; cursor: nesw-resize; }
  .resize-bl{ left: -8px; bottom: -8px; cursor: nesw-resize; }
  .resize-br{ right: -8px; bottom: -8px; cursor: nwse-resize; }
  // 动画效果（tada 复用下方已有 keyframes）
  .anim-tada{ animation: tada 1s ease; }
  .anim-bounce{ animation: bounce 1s ease; }
  .anim-pulse{ animation: pulse 1s ease; }
  .anim-swing{ animation: swing 1s ease; }
  .anim-shake{ animation: shake 1s ease; }
  @keyframes bounce{
    0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
    40% { transform: translateY(-30px); }
    60% { transform: translateY(-15px); }
  }
  @keyframes pulse{
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
  @keyframes swing{
    20% { transform: rotate(15deg); }
    40% { transform: rotate(-10deg); }
    60% { transform: rotate(5deg); }
    80% { transform: rotate(-5deg); }
    100% { transform: rotate(0); }
  }
  @keyframes shake{
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
    20%, 40%, 60%, 80% { transform: translateX(10px); }
  }
  .topBanner{
    width: 750px;
    height: auto;
    min-height: 650px;
    img{
      width: 100%;
      height: auto;
    }
  }
  .titleDown {
      animation: bounceInDown .5s ease 1;
      -webkit-animation: bounceInDown .5s ease 1
  }
  @keyframes bounceInDown {
      0% {
          opacity: 0;
          -webkit-transform: translateY(-2000px)
      }

      60% {
          opacity: 1;
          -webkit-transform: translateY(30px)
      }

      80% {
          -webkit-transform: translateY(-10px)
      }

      100% {
          -webkit-transform: translateY(0)
      }
  }
  .startTada {
      animation: tada .6s ease 0s 1 forwards;
      -webkit-animation: tada .6s ease 0s 1 forwards
  }
  @keyframes tada {
        0% {
            transform: scale3d(1,1,1)
        }

        10%,20% {
            transform: scale3d(.9,.9,.9) rotate3d(0,0,1,-3deg)
        }

        30%,50%,70%,90% {
            transform: scale3d(1.1,1.1,1.1) rotate3d(0,0,1,3deg)
        }

        40%,60%,80% {
            transform: scale3d(1.1,1.1,1.1) rotate3d(0,0,1,-3deg)
        }

        100% {
            transform: scale3d(1,1,1)
        }
    }


  .btnBox{
    width: 100%;
    height: 360px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: column;
    .learn,.rule,.exam{
      width: 300px;
      height: auto;
      img{
        width: 100%;
        height: auto;
      }
    }

  }
  .navBox{
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 750px;
    height: 100px;
    background: #f9f9f9;
    border-top: 1px solid #c8c8c8;
    display: flex;
    justify-content: space-evenly;
    font-size: 30px;
    .navTxt{
      padding:0px 50px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #808080;
      font-weight: 400;
      i{
        font-size: 40px;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        // color:#808080
      }
    }
  } 
  .note{
    // width: 150px;
    padding: 0px 20px;
    padding-right: 15px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #808080b2;
    color: #fff;
    border: 2px solid #ddd;
    border-right: 0px;
    border-top-left-radius: 50px;
    border-bottom-left-radius: 50px;
    font-size: 28px;
    position: absolute;
    left: 50%;
    transform: translateX(calc(-50% + 300px));
    top: 130px;
  }
  //培训规则
  .noticBox{ width: 100%; height: auto; font-size: 30px; padding-bottom: 80px; overflow: hidden;}
  .noticTitle{ display: block; width: 100%; height: 30px; margin-top: 80px; font-size: 34px; display: flex; align-items: center; justify-content: center;}
  .noticTxt{ width: 670; height: auto;  padding:0px 40px; margin-bottom: 30px; overflow: hidden; overflow-y: auto;}
  .noticTxt p{ padding: 0; margin: 15px 0px; width: 100%; text-indent: 2em; text-align: justify;}
  .noticBox .text{ padding: 0px 30px; color:var(--styleColor);}
  .noticBox .line{ border-top: 1px solid var(--styleColor); width: 130px; }

  //登录弹窗
  .loginBox{
    width: 600px;
    padding: 40px;
    padding-bottom: 60px;
    margin: 0 auto;
    .iconfont{ padding-right: 15px; margin-right:20px; border-right: 2px solid #e7e8e8;}
    ::v-deep .van-field__left-icon{
      display: flex;
      align-items: center;
    }
    .loginTitle{
      width: 100%;
      text-align: center;
      font-size: 36px;
      font-weight: bold;
      color: var(--styleColor);
      margin: 20px 0 30px 0;
    }
    .sendCodeBtn{
      background: var(--styleColor);
      color: #fff;
      border: 0px;
      border-radius: 10px;
    }
    .van-cell{
      border: 2px solid #e7e8e8;
      padding: 12px 15px;
      margin-bottom: 30px;
      border-radius: 10px;
    }
    .van-cell::after{ border:0px; }
    .loginPhoneBox{ padding: 4px 5px 4px 15px; }
    .loginBtn{
      margin-top: 20px;
      .van-button{ background: var(--styleColor); border: 0px; border-radius: 15px; }
    }
  }
}

</style>